export enum FeatureName {
  AFFIRM = 'AFFIRM',
  AFTERPAY = 'AFTERPAY',
  GRABPAY = 'GRABPAY',
  STRIPE = 'STRIPE',
  PAYPAL = 'PAYPAL',
  INSTALMENT_TCTP = 'INSTALMENT_TCTP',
  ZIPPAY = 'ZIPPAY',
  APPLE_SIGN_IN = 'APPLE_SIGN_IN',
  FACEBOOK_SIGN_IN = 'FACEBOOK_SIGN_IN',
  GOOGLE_SIGN_IN = 'GOOGLE_SIGN_IN',
  GTM = 'GTM',
  MULBERRY = 'MULBERRY',
  YOTPO = 'YOTPO',
  COOKIE_YES = 'COOKIE_YES',
  UTT_IMPACT = 'UTT_IMPACT',
  LEAD_TIME_FILTER = 'LEAD_TIME_FILTER',
  LEADTIME_DISPLAY = 'LEADTIME_DISPLAY',
  QUICKSHIP = 'QUICKSHIP',
  SUSTAINABILITY_FEATURE = 'SUSTAINABILITY_FEATURE',
}
